import * as api from '../coOpApi';
import { call, put, takeEvery } from 'redux-saga/effects';
import {
    coOpActionCreators,
    CoOpActionKeys,
    FetchCoOpGlobalSettings,
    ICoOpGlobalSettings
    } from '..';
import { uiActionCreators } from '../../ui';

function* fetchCoOpGlobalSettingsSaga(action: FetchCoOpGlobalSettings) {
  yield put(uiActionCreators.toggleLoading('coOpGlobalSettings'));
  const response: ICoOpGlobalSettings = yield call(api.fetchCoOpGlobalSettings, action.payload.fiscalYear);

  yield put(coOpActionCreators.setGlobalSettings(response));
  yield put(uiActionCreators.toggleLoading('coOpGlobalSettings'));
}

export function* watchFetchCoOpGlobalSettings() {
  yield takeEvery(CoOpActionKeys.FETCH_COOP_GLOBAL_SETTINGS, fetchCoOpGlobalSettingsSaga);
}
